



const factorsForDecimals = (decimalPoints: number) => {

  return Math.pow(10, decimalPoints);
};

const formatNumber = (
  value: string | number | undefined | null,
  decimalPoints = 2,
  shorten = false,
  spacer = true,
  trimmer = false,
) => {
  if (value == null) {
    return '...';
  }

  const numericValue = Number(value).toFixed(decimalPoints);
  const factor = factorsForDecimals(decimalPoints);

  const number = Number.parseFloat(numericValue.toString());
  if (Number.isNaN(number)) {
    return '...';
  }
  if (shorten) {
    if (number >= 1.0e7) return `${Math.abs(number) / 1.0e6}m`;
    if (number >= 1.0e4) return `${Math.abs(number) / 1.0e3}k`;
  }
  if (spacer) {
    return (Math.floor(number * factor) / factor)
      .toFixed(decimalPoints)
      .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  }

  // NOTE: added this because when value is 0.00354... for example the floor changes the number to only display 0's
  if (trimmer && spacer) {
    const beforeDotValue = numericValue
      .toString()
      .substr(0, numericValue.toString().indexOf('.'));
    const slicedValue = numericValue
      .toString()
      .substr(value.toString().indexOf('.'), decimalPoints + 1);
    const fullValue = beforeDotValue + slicedValue;

    return fullValue.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  }

  if (trimmer && !spacer) {
    const beforeDotValue = numericValue
      .toString()
      .substr(0, numericValue.toString().indexOf('.'));
    const slicedValue = numericValue
      .toString()
      .substr(numericValue.toString().indexOf('.'), decimalPoints + 1);
    const fullValue = beforeDotValue + slicedValue;

    return fullValue.replace(/\B(?=(\d{3})+(?!\d))/g, '');
  }

  return (Math.floor(number * factor) / factor)
    .toFixed(decimalPoints)
    .replace(/\B(?=(\d{3})+(?!\d))/g, '');
};

const roundDown = (value: number, decimals: number) => {
  const factor = factorsForDecimals(decimals);
  return Math.trunc(Number(value) * factor) / factor;
};

const toFixed = (x: number) => {
  if (Math.abs(x) < 1.0) {

    let e = parseInt(x.toString().split('e-')[1]);
    if (e) {
      x *= Math.pow(10, e - 1);
      // @ts-ignore
      x = `0.${new Array(e).join('0')}${x.toString().substring(2)}`;
    }
  } else {

    let e = parseInt(x.toString().split('+')[1]);
    if (e > 20) {
      e -= 20;
      x /= Math.pow(10, e);
      // @ts-ignore
      x += new Array(e + 1).join('0');
    }
  }
  return x;
};

export const removeNonNumericCharacters = (
  value: string | number | Date | null,
): number => {
  return value === null
    ? 0
    : Number(value?.toString?.().replace(/[^0-9]+/g, ''));
};

export default formatNumber;
